export default "__VITE_ASSET__Csnqvc1X__"